import React from 'react';
import { connect } from 'react-redux';
import FormularioNewton from './FormularioNewton';
import PlotNewton from './PlotNewton';
import Table from './Table';
class NewtonApp extends React.Component {


    render() {
        return (
            <div>
                <h1>Newton's method for root-finding </h1>
                <h5>Implementation for single variable function in <code>Python</code> with <code>sympy</code> and <code>plotly.js</code> for plotting.</h5>
                <div className="ui grid">
                    <div className="row">
                        <div className=" five wide column">
                            <FormularioNewton />
                        </div>
                        <PlotNewton datos={this.props} />
                    </div>
                    <div className="ui container">
                        <Table datos={this.props} />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        solution: state.solution_newton,
        form: state.form.datosNewton
    };
}


export default connect(mapStateToProps,)(NewtonApp);